import {useGlobalStore} from "@/stores/GlobalStore";

export default function resetFooterCounter ({next}:any){
    const globalStore = useGlobalStore();

    globalStore.currentItems = 0;
    globalStore.allItems = 0;

    return next();
}
